import React, { forwardRef, RefObject } from 'react';
import { clsx } from 'clsx';
import { MenuBarComponent } from 'src/components/PageContentWrapper/MenuBarComponent';

const PageContentWrapper = forwardRef(
  (
    {
      className = '',
      menuBarVisible = true,
      children,
      projectBreadcrumbsContent = '',
      isMobileMarginTop = true,
      isProjectBreadcrumbs = false,
      showFilter,
      mobileFilterModal,
    }: {
      className?: string;
      menuBarVisible?: boolean;
      children: any;
      projectBreadcrumbsContent?: string;
      isMobileMarginTop?: boolean;
      isProjectBreadcrumbs?: boolean;
      showFilter?: boolean;
      mobileFilterModal?: any;
    },
    ref: RefObject<HTMLDivElement>,
  ) => {
    return (
      <div
        className={clsx(
          className,
          'container relative z-1 flex flex-col gap-[10px] pb-[20px] px-5 md:pb-[40px] pt-[15px]',
        )}
        ref={ref}
      >
        {menuBarVisible && <MenuBarComponent />}
        {children}
      </div>
    );
  },
);

export default PageContentWrapper;
